import jwtDecode from "jwt-decode";

const HARDCODED_TOKEN = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiQUNENzBCQTgtMzEzMS00ODBCLUExMUItOERCQzlBNEUxNUY0IiwiaWgiOiJtWUJJMFJQcjRmZzI3dS9tU1N5ZStvL2w4SXBjRkJ3ZXltNXNiOTJoWjdVPSIsImlzIjoiZmJlVVBBdkZyN0t6UXJwOXc2bVY2Zz09IiwicGgiOiIvSG1CMjU0cjczdlNaVHUwTk1DUmhsQURyTjBPcEVVZnp6T1hoUnphMEVvPSIsInBzIjoiMk9yb1pxL1E0L3hHclRzNkhkd3lsdz09IiwicGxhdGZvcm0iOiJXZWIiLCJpc0FnZW50IjoiRmFsc2UiLCJqdGkiOiJjOTIwMTE3Ni1hNDM4LTRkNzMtODdjOC02ZDdlMjJjZTJmNDIiLCJuYmYiOjE3ODQ3ODU3NzcsImV4cCI6MTc4NDk1ODU3N30.LEcrEq8K2L6PhQwveVhSzdasexS8tR8iXvR4-x-UIQuO34QahuLLpboJ-BM76VU-n5PcVSCdjUHesMGDuwcSsyswig4eMZwpkMJhpBSgu1O7xKHixOT3Ina_4hl6c7Mc9Sm7zZSwgDPmF-JrvJIw-MXElrzD4BwzLRD8fBKcxYilFUXu-6rPfFGo0nDxqwGZ6c3fGkrYrkxfHFJH5XrQh6HrnM8U_TQ30HmUZbCeCLtc9kt-1pGV5lfYj5JlhkTnPyoJwrmuwtGdvBvwLWH0Ldvo4jw3GRXbcoPHu9pH4x5fTOASZVMoTPGUO8qesXyiIv2ofCbG4tADF4Xk2F664w";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token");
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || HARDCODED_TOKEN;
  return finalToken;
}

export function decodeWorkWiseToken() {
  const token = getWorkWiseAuthToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export const getUserInfoFromToken = () => {
  try {
    const token = getWorkWiseAuthToken();

    if (!token) return null;

    const decoded = jwtDecode(token);

    return decoded || null;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};
